// Cosa può fare ogni ruolo nell'app. Sono le stesse regole di firestore.rules (che restano la vera protezione):
// qui servono solo per mostrare o nascondere pulsanti e sezioni.
const ha = (ruoli, lista) => (ruoli || []).some((r) => lista.includes(r));

/** Responsabile o sviluppo: approva i telefoni, cambia turni, P.P e nomi delle operatrici. */
export const admin = (ruoli) => ha(ruoli, ['responsabile', 'dev']);
/** Crea, modifica e disdice le prenotazioni. */
export const puoPrenotare = (ruoli) => ha(ruoli, ['ricevimento', 'responsabile', 'dev']);
/** Vede e scrive i dati di salute (GDPR art. 9): mai il ricevimento. */
export const vedeSalute = (ruoli) => ha(ruoli, ['responsabile', 'operatrice', 'dev']);
/** Colonna dell'operatrice (op1…op3) del telefono, solo se ha il ruolo di operatrice. */
export const miaColonna = (dispositivo) => ((dispositivo?.ruoli || []).includes('operatrice') && dispositivo.op) || null;
